import { useFlags } from 'launchdarkly-react-client-sdk';

import { useCore } from '@phoenix/core/frontend/shared/feature/context/core.context';
import { useQueryContextMemo } from '@phoenix/team-m/dashboard/frontend/shared/use-query-context-memo';
import { useGetProductCompatibleBatteriesQuery } from '@phoenix/team-m/dashboard/frontend/domain/generated/graphql';
import { reduceProductsWithLagerCapacityBatteries } from '@phoenix/team-m/dashboard/frontend/util/product/product-batteries.mapper';
import { ProductCompatibleBatteries } from '@phoenix/team-m/dashboard/frontend/util/product/product-batteries.model';

export const useProductCompatibleBatteries = (): { productCompatibleBatteries: ProductCompatibleBatteries[] } => {
  const {
    auth: { user },
  } = useCore();

  const stihlId = user?.stihl_id || '';
  const { 'compatible-batteries': flagEnabled } = useFlags();

  const [{ data }] = useGetProductCompatibleBatteriesQuery({
    pause: !stihlId || !flagEnabled,
    context: useQueryContextMemo(process.env.NEXT_PUBLIC_TOOL_SHED_GRAPHQL_BASE_URL),
  });

  return {
    productCompatibleBatteries: reduceProductsWithLagerCapacityBatteries(
      data?.productRecommendations?.compatibleProducts?.productCompatibleBatteries
    ),
  };
};
